export enum AsanVerifyActionTypes {
  FETCH_ASAN_VERIFY_REQUEST = 'FETCH_ASAN_VERIFY_REQUEST',
  FETCH_ASAN_VERIFY_SUCCESS = 'FETCH_ASAN_VERIFY_SUCCESS',
  FETCH_ASAN_VERIFY_FAILED = 'FETCH_ASAN_VERIFY_FAILED',
}

export interface AsanVerifyResponse {
    transactionId: string
    dateTime: string
    organitaztionId: string
}

export interface AsanAdocResponse {
  url: string
}

export interface AsanVerifyRequest {
    transactionId: string;
}

export interface AsanVerifyState {
  status: 'idle' | 'loading' | 'success' | 'failed'
  error: null | any
  loading: boolean
  data: null | AsanVerifyResponse
}

export interface FetchAsanVerifyRequest {
  type: AsanVerifyActionTypes.FETCH_ASAN_VERIFY_REQUEST
}

export interface FetchAsanVerifySuccess {
  type: AsanVerifyActionTypes.FETCH_ASAN_VERIFY_SUCCESS
  payload: AsanVerifyResponse
}

export interface FetchAsanVerifyFailed {
  type: AsanVerifyActionTypes.FETCH_ASAN_VERIFY_FAILED
  payload: string
}

export type AsanVerifyActions =
  | FetchAsanVerifyRequest
  | FetchAsanVerifySuccess
  | FetchAsanVerifyFailed
